import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import LoadingIcon from "../../LoadingIcon";
import SuccessMessageModel from "../../SuccessMessageModel";

import { GetApi, PostApi } from "../../../js_assets/Network";
import { getParameterByName } from "../../../js_assets/getParameterByName";

import AppAdminContainer from "../AppAdminContainer";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";

import Dialog from "@material-ui/core/Dialog";

import DialogTitle from "@material-ui/core/DialogTitle";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  input: {
    paddingRight: 10,
    flex: 1,
  },
  divwidth: {
    width: "60%",
  },
  btn_login: {
    color: "white",
    padding: "1px 1px",
    border: "none",
    cursor: "pointer",
    width: "250px",
    opacity: "0.9",
    borderRadius: "3px",
  },
  btn_Resetfrom: {
    color: "white",
  },
});

class FormDiscountCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Trainers: [],
      Stores: [],
      successmessage: false,
      loading_state_iocn: true,
      discount_Code_Id: 0,
      discount_Code_data: {
        discount_Code_Id: 0,
        advertiser_Name: "",
        coupon_Code: " ",
        discount_Percent: "0.05",
        expiry_Code_Date: "",
        count_Use_Code: 0,
        count_Purchased_By_Code: 0,
        type_Discount_Code_For: "",
        discount_Condition: 0,
        iD_Discount_Code_For: "",
        exception_Discount_Ids: "",
      },
      Admin_Info: JSON.parse(localStorage.getItem("Admin_Info")),
    };
  }

  componentDidMount() {
    const { Admin_Info } = this.state;

    let test_text = "100,15,1";

    console.log("test_text", test_text.split(","));

    let ActionType_CodeId = getParameterByName("CodeId");

    Promise.all([
      GetApi(
        `/api/admin/Get_Trainers_Id_Name/${Admin_Info.admin_Id}`,
        Admin_Info.jwT_Token_Admin
      ),
      GetApi(
        `/api/store/GetStores/${Admin_Info.admin_Id}`,
        Admin_Info.jwT_Token_Admin
      ),
    ]).then((result) => {
      //console.log(result)
      this.setState({ Trainers: result[0], Stores: result[1] });

      if (ActionType_CodeId !== null) {
        if (ActionType_CodeId !== "New") {
          GetApi(
            `/api/admin/Get_Discount_Code/${ActionType_CodeId}/${Admin_Info.admin_Id}`,
            Admin_Info.jwT_Token_Admin
          ).then((result) => {
            this.setState({
              discount_Code_Id: result.discount_Code_Id,
              discount_Code_data: result,
            });

            this.refs.advertiser_Name.value = result.advertiser_Name;

            this.refs.type_Discount_Code_For.value =
              result.type_Discount_Code_For;

            this.refs.iD_Discount_Code_For.value =
              result.iD_Discount_Code_For === "all"
                ? result.iD_Discount_Code_For
                : "specific";

            this.refs.List_Store_Id.value =
              result.type_Discount_Code_For === "store" &&
                result.iD_Discount_Code_For !== "all"
                ? parseInt(result.iD_Discount_Code_For)
                : null;

            this.refs.List_trainer_Id.value =
              result.type_Discount_Code_For === "subscription_schedule" &&
                result.iD_Discount_Code_For !== "all"
                ? parseInt(result.iD_Discount_Code_For)
                : null;

            this.refs.coupon_Code.value = result.coupon_Code;

            this.refs.expiry_Code_Date.value = result.expiry_Code_Date.split(
              "T"
            )[0];

            this.refs.discount_Percent_list.value = result.discount_Percent;

            this.refs.discount_Condition.value = result.discount_Condition;
          });
        }
      }

      this.setState({ loading_state_iocn: false });
    });
  }

  Save_Discount_Code = (e) => {
    const { Admin_Info, discount_Code_data } = this.state;

    e.preventDefault();

    this.setState({ loading_state_iocn: true });

    PostApi(
      `/api/admin/Save_Discount_Code/${Admin_Info.admin_Id}`,
      discount_Code_data,
      Admin_Info.jwT_Token_Admin
    ).then(() => {
      this.setState({ successmessage: true, loading_state_iocn: false });
    });
  };

  onChange_advertiser_Name = (e) => {
    const { discount_Code_data } = this.state;
    let new_discount_Code_data = discount_Code_data;
    new_discount_Code_data.advertiser_Name = e.target.value;
    this.setState({ discount_Code_data: new_discount_Code_data });
  };

  onChange_ID_Discount_Code_For = (e) => {
    const { discount_Code_data } = this.state;
    let new_discount_Code_data = discount_Code_data;
    new_discount_Code_data.iD_Discount_Code_For = e.target.value;
    this.setState({ discount_Code_data: new_discount_Code_data });
  };

  onChange_type_Discount_Code_For = (e) => {
    const { discount_Code_data } = this.state;
    let new_discount_Code_data = discount_Code_data;
    new_discount_Code_data.type_Discount_Code_For = e.target.value;
    this.setState({ discount_Code_data: new_discount_Code_data });
  };

  onChange_coupon_Code = (e) => {
    const { discount_Code_data } = this.state;
    let new_discount_Code_data = discount_Code_data;
    new_discount_Code_data.coupon_Code = e.target.value;
    this.setState({ discount_Code_data: new_discount_Code_data });
  };

  onChange_discount_Condition = (e) => {
    const { discount_Code_data } = this.state;
    let new_discount_Code_data = discount_Code_data;
    new_discount_Code_data.discount_Condition = parseInt(e.target.value);
    this.setState({ discount_Code_data: new_discount_Code_data });
  };

  onChange_discount_Percent_list = (e) => {
    const { discount_Code_data } = this.state;
    let new_discount_Code_data = discount_Code_data;

    console.log("onChange_discount_Percent_list", parseFloat(e.target.value / 100))
    new_discount_Code_data.discount_Percent = parseFloat(e.target.value / 100).toFixed(3).toString();
    this.setState({ discount_Code_data: new_discount_Code_data });
  };

  onChange_expiry_Code_Date = (e) => {
    const { discount_Code_data } = this.state;
    let new_discount_Code_data = discount_Code_data;
    new_discount_Code_data.expiry_Code_Date = e.target.value;
    this.setState({ discount_Code_data: new_discount_Code_data });
  };

  Exception_Discount_Ids = (type) => {
    const { discount_Code_data } = this.state;

    if (type === "subscription_schedule") {
      let new_discount_Code_data = discount_Code_data;

      new_discount_Code_data.exception_Discount_Ids =
        new_discount_Code_data.exception_Discount_Ids.length === 0
          ? this.refs.List_trainer_Id_Exception.value
          : new_discount_Code_data.exception_Discount_Ids +
          "-" +
          this.refs.List_trainer_Id_Exception.value;
    } else {
      let new_discount_Code_data = discount_Code_data;

      new_discount_Code_data.exception_Discount_Ids =
        new_discount_Code_data.exception_Discount_Ids.length === 0
          ? this.refs.List_Store_Id_Exception.value
          : new_discount_Code_data.exception_Discount_Ids +
          "-" +
          this.refs.List_Store_Id_Exception.value;
    }

    alert("تم الاضافة");
  };

  render() {
    const { classes } = this.props;
    const {
      Trainers,
      Stores,
      loading_state_iocn,
      discount_Code_data,
      successmessage,
    } = this.state;
    let option_Item_Trainers = Trainers.map((item) => (
      <option value={item.trainer_Id} key={item.trainer_Id}>
        {item.trainer_Name}
      </option>
    ));

    let option_Item_Stores = Stores.map((item) => (
      <option value={item.store_Id} key={item.store_Id}>
        {item.store_Name}
      </option>
    ));

    return (
      <AppAdminContainer Title={"كود الخصم"}>
        <div className="container">

          <form>
            <input
              ref="discount_Code_Id"
              value={this.state.discount_Code_Id}
              hidden
            />
            <div class="row">
              <div class="col-75">
                <label >اسم المعلن</label>
              </div>
              <div class="col-75">
                <input
                  onChange={(e) => this.onChange_advertiser_Name(e)}

                  placeholder="اسم المعلن"
                  ref="advertiser_Name"
                  required
                />
              </div>
            </div>

            <br />
            <span>نوع الخصم </span>
            <select
              onChange={(e) => this.onChange_type_Discount_Code_For(e)}
              ref="type_Discount_Code_For"

              name="type_Discount_Code_For"
            >
              <option value="0">اختر نوع الخصم</option>
              <option value="subscription_schedule">للجداول</option>
              <option value="store">للمتاجر</option>
            </select>

            <br />

            <span>فئه الخصم </span>
            <select
              onChange={(e) => this.onChange_ID_Discount_Code_For(e)}
              ref="iD_Discount_Code_For"

              name="iD_Discount_Code_For"
            >
              <option value="0">اختر فئه للخصم</option>
              <option value="all">للجميع</option>
              <option value="specific">محدد</option>
            </select>
            <br />

            <span> كود الخصم </span>
            <input
              onChange={(e) => this.onChange_coupon_Code(e)}

              placeholder="كود الخصم"
              name="coupon_Code"
              ref="coupon_Code"
              required
            />

            <br />
            <span> شرط الخصم </span>
            <input
              type="number"
              onChange={(e) => this.onChange_discount_Condition(e)}

              placeholder="شرط الخصم"
              name="discount_Condition"
              ref="discount_Condition"
            />
            <br />
            <span>نسبة الخصم </span>


            <input
              onChange={(e) => this.onChange_discount_Percent_list(e)}
              ref="discount_Percent_list"
              name="discount_Percent_list"
              placeholder="نسبة الخصم"
            />

            <br />

            <div
              hidden={
                discount_Code_data.iD_Discount_Code_For !== "all" &&
                  discount_Code_data.type_Discount_Code_For === "store"
                  ? false
                  : true
              }
            >
              <span> المتجر</span>
              <select
                onChange={(e) => this.onChange_ID_Discount_Code_For(e)}

                ref="List_Store_Id"
              >
                {option_Item_Stores}
              </select>
            </div>

            {discount_Code_data.type_Discount_Code_For === "store" &&
              discount_Code_data.iD_Discount_Code_For === "all" && (
                <div>
                  <div className="center" >
                    <span> المتجر المستثنى</span>
                    <select

                      ref="List_Store_Id_Exception"
                    >
                      {option_Item_Stores}
                    </select>
                  </div>
                  <div className="center" >
                    <button
                      onClick={(e) => this.Exception_Discount_Ids("store")}
                      variant="contained"
                      type="Submit"
                      color="secondary"
                      className={classes.btn_login}
                    >
                      <label>استثناء المتجر</label>
                    </button>
                  </div>
                </div>
              )}

            <br />

            <div
              hidden={
                discount_Code_data.type_Discount_Code_For ===
                  "subscription_schedule" &&
                  discount_Code_data.iD_Discount_Code_For !== "all"
                  ? false
                  : true
              }
            >
              <span> المدرب المستثنى</span>
              <select
                onChange={(e) => this.onChange_ID_Discount_Code_For(e)}

                ref="List_trainer_Id"
              >
                {option_Item_Trainers}
              </select>
            </div>

            {discount_Code_data.type_Discount_Code_For ===
              "subscription_schedule" &&
              discount_Code_data.iD_Discount_Code_For === "all" && (
                <div>
                  <div className="center" >
                    <select

                      ref="List_trainer_Id_Exception"
                    >
                      {option_Item_Trainers}
                    </select>
                  </div>
                  <div className="center" >
                    <button
                      onClick={() =>
                        this.Exception_Discount_Ids("subscription_schedule")
                      }


                    >
                      استثناء المدرب
                    </button>
                  </div>
                </div>
              )}

            <br />

            <span> الانتهاء</span>
            <input
              onChange={(e) => this.onChange_expiry_Code_Date(e)}

              placeholder="تاريخ الانتهاء  مثال  MM-dd-yyyy"
              name="expiry_Code_Date"
              ref="expiry_Code_Date"
              type={"Date"}
            />

            <br />
            <br />


            <button
              onClick={(e) => this.Save_Discount_Code(e)}
              type="Submit"
            >
              <label>حفظ</label>
            </button>




            {loading_state_iocn ? <LoadingIcon /> : null}
            {successmessage ? (
              <SuccessMessageModel SuccessMessageText={"تم الحفظ"} />
            ) : null}

          </form>
        </div>


      </AppAdminContainer>
    );
  }
}
FormDiscountCode.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FormDiscountCode);
